import { render } from "./RenewCertificate.vue?vue&type=template&id=da2b5802&scoped=true"
import script from "./RenewCertificate.vue?vue&type=script&lang=js"
export * from "./RenewCertificate.vue?vue&type=script&lang=js"

import "./RenewCertificate.vue?vue&type=style&index=0&id=da2b5802&lang=scss&scoped=true"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2b5802"]])

export default __exports__